'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.currentLocationSelector = exports.wixInstalledAppsSelector = exports.accessTokenSelector = exports.wixInstanceSelector = exports.i18nDataSelector = exports.i18nSelector = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var getEmptyOrganizationWithTimezone = function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref6) {
        var userId = _ref6.userId,
            locale = _ref6.locale,
            currency = _ref6.currency,
            properties = _ref6.properties,
            fetch = _ref6.fetch,
            Intl = _ref6.Intl,
            LocalStorage = _ref6.LocalStorage,
            defaultDispatchType = _ref6.defaultDispatchType;

        var organization, geocode, _geocode, countryCode, country, region, geoTimezone, lat, lng, timezone, newOrgOverride, ret;

        return _regenerator2.default.wrap(function _callee$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        organization = (0, _extends3.default)({}, getEmptyOrganization({ userId: userId, locale: locale, currency: currency, defaultDispatchType: defaultDispatchType }), { properties: properties });
                        geocode = {};
                        _context5.prev = 2;
                        _context5.next = 5;
                        return fetch('https://freegeoip.net/json/', { mode: 'cors' }).then(function (r) {
                            return r.json();
                        });

                    case 5:
                        geocode = _context5.sent;
                        _context5.next = 10;
                        break;

                    case 8:
                        _context5.prev = 8;
                        _context5.t0 = _context5['catch'](2);

                    case 10:
                        _geocode = geocode, countryCode = _geocode.country_code, country = _geocode.country_name, region = _geocode.region_name, geoTimezone = _geocode.time_zone, lat = _geocode.latitude, lng = _geocode.longitude;


                        if (countryCode) {
                            organization.address.countryCode = countryCode;
                        }

                        if (region && country) {
                            organization.address.formatted = _lodash2.default.startCase(region) + ', ' + _lodash2.default.startCase(country);
                        }

                        if (typeof lat !== 'undefined' && typeof lng !== 'undefined') {
                            organization.address.latLng = { lat: lat, lng: lng };
                            organization.timezone = null;
                        }

                        timezone = null;

                        try {
                            if (Intl && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions) {
                                timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                            }
                        } catch (e) {}

                        if (timezone) {
                            organization.timezone = timezone;
                        } else if (geoTimezone) {
                            organization.timezone = geoTimezone;
                        } else {
                            organization.address.formatted = '[noskip]';
                        }

                        newOrgOverride = LocalStorage ? LocalStorage.get('new-org-override') : null;
                        ret = _lodash2.default.defaultsDeep(newOrgOverride || {}, organization);
                        return _context5.abrupt('return', ret);

                    case 20:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee, this, [[2, 8]]);
    }));

    return function getEmptyOrganizationWithTimezone(_x) {
        return _ref7.apply(this, arguments);
    };
}();

var setCashierIfNeeded = function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(organization) {
        return _regenerator2.default.wrap(function _callee2$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        try {
                            _wixrestUtils.PropertiesUtils.set(organization, 'wixrestaurants.useCashier', true, 'com.wix.restaurants');
                        } catch (err) {
                            console.error('setCashierIfNeeded', err);
                        }

                    case 1:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee2, this);
    }));

    return function setCashierIfNeeded(_x2) {
        return _ref8.apply(this, arguments);
    };
}();

var setFutureOrderMinTimeIfNeeded = function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(organization) {
        var experiments, path, currentMinValue;
        return _regenerator2.default.wrap(function _callee3$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.prev = 0;
                        experiments = new _wixExperiments2.default({ scope: 'restaurants' });
                        _context7.next = 4;
                        return experiments.ready();

                    case 4:
                        path = 'orders.future.delayMins.min';
                        currentMinValue = _lodash2.default.get(organization, path);

                        if (experiments.enabled('specs.restaurants.future-orders-min-time') && currentMinValue) {
                            _lodash2.default.set(organization, path, 120);
                        }
                        _context7.next = 12;
                        break;

                    case 9:
                        _context7.prev = 9;
                        _context7.t0 = _context7['catch'](0);

                        console.error('setFutureOrderMinTimeIfNeeded', _context7.t0);

                    case 12:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee3, this, [[0, 9]]);
    }));

    return function setFutureOrderMinTimeIfNeeded(_x3) {
        return _ref9.apply(this, arguments);
    };
}();

var createNewRestaurantFromOriginFull = function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(_ref10) {
        var _this = this;

        var userId = _ref10.userId,
            originFull = _ref10.originFull,
            accessToken = _ref10.accessToken,
            openrest = _ref10.openrest,
            wixInstance = _ref10.wixInstance,
            fetch = _ref10.fetch,
            Intl = _ref10.Intl,
            uuid = _ref10.uuid,
            bsmMode = _ref10.bsmMode,
            LocalStorage = _ref10.LocalStorage,
            authentication = _ref10.authentication,
            restClient = _ref10.restClient,
            mappingClient = _ref10.mappingClient;

        var _originFull$restauran, locale, currency, properties, newOrganization, organization, metasiteId, syncSource, organizationWithExternalIds, loginResponse, auth, cloneRequest;

        return _regenerator2.default.wrap(function _callee5$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _originFull$restauran = originFull.restaurant, locale = _originFull$restauran.locale, currency = _originFull$restauran.currency, properties = _originFull$restauran.properties;
                        _context9.next = 3;
                        return getEmptyOrganizationWithTimezone({ userId: userId, locale: locale, currency: currency, properties: properties, fetch: fetch, Intl: Intl, LocalStorage: LocalStorage, defaultDispatchType: 'takeout' });

                    case 3:
                        newOrganization = _context9.sent;
                        _context9.next = 6;
                        return setCashierIfNeeded(newOrganization);

                    case 6:
                        _context9.next = 8;
                        return setFutureOrderMinTimeIfNeeded(newOrganization);

                    case 8:
                        _context9.next = 10;
                        return restClient('/organizations', 'post', newOrganization, { type: 'Bearer', credentials: accessToken });

                    case 10:
                        organization = _context9.sent;
                        metasiteId = getMetasiteId(wixInstance);
                        syncSource = bsmMode ? 'businessManager' : 'restaurantsDashboard';
                        _context9.next = 15;
                        return syncBusinessInfo(metasiteId, fetch, syncSource);

                    case 15:
                        if (!featureToggles.METASITE_ORG_MAPPING) {
                            _context9.next = 25;
                            break;
                        }

                        _context9.prev = 16;
                        _context9.next = 19;
                        return openrest.request({
                            request: {
                                type: 'map_wix_metasite',
                                instance: wixInstance.value,
                                metasiteId: metasiteId,
                                organizationId: organization.id
                            }
                        });

                    case 19:
                        _context9.next = 23;
                        break;

                    case 21:
                        _context9.prev = 21;
                        _context9.t0 = _context9['catch'](16);

                    case 23:
                        _context9.next = 32;
                        break;

                    case 25:
                        organizationWithExternalIds = getOrganizationWithWixExternalId(organization, wixInstance);
                        _context9.next = 28;
                        return authentication('/com.wix.instances/access_token', 'post', { instance: wixInstance.value });

                    case 28:
                        loginResponse = _context9.sent;
                        auth = { 'type': 'Bearer', 'credentials': loginResponse.accessToken };
                        _context9.next = 32;
                        return _promise2.default.all([(0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                            var err;
                            return _regenerator2.default.wrap(function _callee4$(_context8) {
                                while (1) {
                                    switch (_context8.prev = _context8.next) {
                                        case 0:
                                            // instance should not already be mapped
                                            err = true;
                                            _context8.prev = 1;
                                            _context8.next = 4;
                                            return mappingClient('/instances/' + _lodash2.default.get(wixInstance, 'parsed.instanceId'));

                                        case 4:
                                            _context8.next = 9;
                                            break;

                                        case 6:
                                            _context8.prev = 6;
                                            _context8.t0 = _context8['catch'](1);

                                            err = _context8.t0.type !== 'https://mapping.wixrestaurants.com/errors/resource-not-found';

                                        case 9:
                                            if (!err) {
                                                _context8.next = 11;
                                                break;
                                            }

                                            throw { type: 'network-error' };

                                        case 11:
                                            _context8.prev = 11;
                                            _context8.next = 14;
                                            return mappingClient('/instances/' + _lodash2.default.get(wixInstance, 'parsed.instanceId'), 'put', { organizationId: organization.id }, auth);

                                        case 14:
                                            _context8.next = 19;
                                            break;

                                        case 16:
                                            _context8.prev = 16;
                                            _context8.t1 = _context8['catch'](11);
                                            throw { type: 'network-error' };

                                        case 19:
                                        case 'end':
                                            return _context8.stop();
                                    }
                                }
                            }, _callee4, _this, [[1, 6], [11, 16]]);
                        }))(), restClient('/organizations/' + organizationWithExternalIds.id, 'put', organizationWithExternalIds, { type: 'Bearer', credentials: accessToken })]);

                    case 32:
                        if (!(originFull.menu && !_lodash2.default.isEmpty(originFull.menu.items))) {
                            _context9.next = 36;
                            break;
                        }

                        cloneRequest = _Menu2.default.createCloneMenuRequest({
                            sourceMenu: originFull.menu,
                            sourceLocale: originFull.restaurant.locale,
                            destRestaurantId: organization.id,
                            locale: organization.locale,
                            copyCharges: false,
                            genId: function genId() {
                                return uuid();
                            }
                        });
                        _context9.next = 36;
                        return restClient('/organizations/' + cloneRequest.organizationId + '/menu', 'put', cloneRequest.menu, { type: 'Bearer', credentials: accessToken });

                    case 36:
                        _context9.next = 38;
                        return restClient('/organizations/' + organization.id + '/full');

                    case 38:
                        return _context9.abrupt('return', _context9.sent);

                    case 39:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee5, this, [[16, 21]]);
    }));

    return function createNewRestaurantFromOriginFull(_x4) {
        return _ref11.apply(this, arguments);
    };
}();

var syncBusinessInfo = function () {
    var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(metasiteId, fetch, source) {
        return _regenerator2.default.wrap(function _callee6$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        _context10.prev = 0;
                        _context10.next = 3;
                        return _wixrestUtils.restaurantsSyncService.syncRestaurantWithBusinessInfo({
                            metasiteId: metasiteId,
                            fetch: fetch,
                            source: source
                        });

                    case 3:
                        _context10.next = 8;
                        break;

                    case 5:
                        _context10.prev = 5;
                        _context10.t0 = _context10['catch'](0);

                        console.error('business info sync failed', _context10.t0);

                    case 8:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee6, this, [[0, 5]]);
    }));

    return function syncBusinessInfo(_x5, _x6, _x7) {
        return _ref13.apply(this, arguments);
    };
}();

exports.handleLoadFull = handleLoadFull;
exports.handleSecondaryLocale = handleSecondaryLocale;
exports.getEmptyOrganization = getEmptyOrganization;
exports.default = webInitRootSaga;

var _effects = require('redux-saga/effects');

var _WebInitActions = require('../actions/WebInitActions');

var _JointLoginActions = require('../actions/JointLoginActions');

var _WixInstanceActions = require('../actions/WixInstanceActions');

var _LocationsActions = require('../actions/LocationsActions');

var _I18nActions = require('../actions/I18nActions');

var I18nActions = _interopRequireWildcard(_I18nActions);

var _WixInstalledAppsActions = require('../actions/WixInstalledAppsActions');

var WixInstalledAppsActions = _interopRequireWildcard(_WixInstalledAppsActions);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _Menu = require('@wix/wixrest-utils/dist/openrest-helpers/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _LocalStorage = require('@wix/wixrest-utils/dist/LocalStorage');

var _LocalStorage2 = _interopRequireDefault(_LocalStorage);

var _OrganizationFullRetrieval = require('@wix/wixrest-utils/dist/OrganizationFullRetrieval');

var _guid = require('../guid');

var _guid2 = _interopRequireDefault(_guid);

var _featureToggles = require('../featureToggles');

var featureToggles = _interopRequireWildcard(_featureToggles);

var _wixrestUtils = require('@wix/wixrest-utils');

var _fixInvalidDeliveryInfos = require('./fixInvalidDeliveryInfos');

var _wixExperiments = require('@wix/wix-experiments');

var _wixExperiments2 = _interopRequireDefault(_wixExperiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(handleInit),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleLoadFull),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleSecondaryLocale),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleLoadFullSingle),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(waitForLoadFull),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(waitForSecondaryLocale),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(webInitRootSaga);

var MAX_DELAY_MINUTES = 60 * 24 * 30 * 6;
var DEFAULT_PHONE_NUMBER = '+18005551111';

function handleInit(sagaParams) {
    var _window, _ref, payload, uxLanguage, i18nUxMode, queryHash, appId, skipInstalledApps, facebookPageId, system, forceId, skipOrganizationI18nChange, locationId, migrateToMultiLocationIfNeeded, loadCompactMenus, useMultilocation, i18nSecondarySwitched, i18nData, _ref2, i18n, wixInstance;

    return _regenerator2.default.wrap(function handleInit$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!true) {
                        _context.next = 41;
                        break;
                    }

                    _window = sagaParams.window;

                    // Wait for the first INIT_WEB action

                    _context.next = 4;
                    return (0, _effects.take)(_WebInitActions.types.INIT_WEB);

                case 4:
                    _ref = _context.sent;
                    payload = _ref.payload;
                    uxLanguage = payload.uxLanguage, i18nUxMode = payload.i18nUxMode, queryHash = payload.queryHash, appId = payload.appId, skipInstalledApps = payload.skipInstalledApps, facebookPageId = payload.facebookPageId, system = payload.system, forceId = payload.forceId, skipOrganizationI18nChange = payload.skipOrganizationI18nChange, locationId = payload.locationId, migrateToMultiLocationIfNeeded = payload.migrateToMultiLocationIfNeeded, loadCompactMenus = payload.loadCompactMenus, useMultilocation = payload.useMultilocation;


                    console.log('[Restaurants] - WebInitSaga: useMultilocation= ' + useMultilocation + ', migrateToMultiLocationIfNeeded= ' + migrateToMultiLocationIfNeeded);
                    // Should we be in secondary-language (based on LocalStorage)?

                    i18nSecondarySwitched = function () {
                        try {
                            return (_LocalStorage2.default.get('i18nstore') || {}).secondarySwitched || false;
                        } catch (e) {
                            return false;
                        }
                    }();

                    _context.next = 11;
                    return (0, _effects.select)(i18nDataSelector);

                case 11:
                    i18nData = _context.sent;

                    if (i18nData.locale) {
                        _context.next = 15;
                        break;
                    }

                    _context.next = 15;
                    return (0, _effects.put)(I18nActions.actions.i18nInit({
                        uxMode: i18nUxMode,
                        localeData: _window.spiceI18n,
                        uxLanguage: _window.uxLanguage || uxLanguage,
                        secondChoiceLocale: _window.secondChoiceLocale,
                        secondarySwitched: i18nSecondarySwitched
                    }));

                case 15:
                    _context.next = 17;
                    return (0, _effects.select)(i18nSelector);

                case 17:
                    _ref2 = _context.sent;
                    i18n = _ref2.i18n;


                    // For legacy - store i18n in window.theI18n. TODO: Remove all references to theI18n
                    _window.theI18n = i18n;

                    // If we have a Wix instance , initialize it by calling an action

                    if (!queryHash.instance) {
                        _context.next = 23;
                        break;
                    }

                    _context.next = 23;
                    return (0, _effects.put)(_WixInstanceActions.actions.setInstance({
                        instance: queryHash.instance,
                        appId: appId
                    }));

                case 23:
                    _context.next = 25;
                    return (0, _effects.select)(wixInstanceSelector);

                case 25:
                    wixInstance = _context.sent;

                    _window.WixInstance = wixInstance.instance; // For debugging

                    // If we are not in a facebook page, not forced to a specific restaurant, and are in a Wix site,
                    // get the other apps installed

                    if (!(!skipInstalledApps && !facebookPageId && !forceId && queryHash.instance)) {
                        _context.next = 30;
                        break;
                    }

                    _context.next = 30;
                    return (0, _effects.put)(WixInstalledAppsActions.actions.getInstalledApps());

                case 30:
                    if (!(wixInstance.parsed && wixInstance.parsed.uid)) {
                        _context.next = 35;
                        break;
                    }

                    _context.next = 33;
                    return (0, _effects.put)(_JointLoginActions.actions.loginWithWix({ instance: wixInstance.value }));

                case 33:
                    _context.next = 37;
                    break;

                case 35:
                    _context.next = 37;
                    return (0, _effects.put)(_JointLoginActions.actions.setAccessToken({ accessToken: queryHash.accessToken }));

                case 37:
                    _context.next = 39;
                    return (0, _effects.put)(_WebInitActions.actions.loadFull({
                        facebookPageId: facebookPageId,
                        system: system,
                        forceId: forceId,
                        skipI18nRequestChange: skipOrganizationI18nChange,
                        locationId: locationId,
                        migrateToMultiLocationIfNeeded: migrateToMultiLocationIfNeeded,
                        loadCompactMenus: loadCompactMenus,
                        useMultilocation: useMultilocation
                    }));

                case 39:
                    _context.next = 0;
                    break;

                case 41:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
};

var latestIterationId = void 0;

/**
 * Handle action to load the 'restaurant-full'.
 */
function handleLoadFull(sagaParams, action) {
    var _action$payload, system, skipI18nRequestChange, migrateToMultiLocationIfNeeded, loadCompactMenus, _sagaParams$delay, delay, sentryClient, full, wixInstance, hostName, multiLocationData, isMigrationExecuted, iterationId, timeout, locationId;

    return _regenerator2.default.wrap(function handleLoadFull$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _action$payload = action.payload, system = _action$payload.system, skipI18nRequestChange = _action$payload.skipI18nRequestChange, migrateToMultiLocationIfNeeded = _action$payload.migrateToMultiLocationIfNeeded, loadCompactMenus = _action$payload.loadCompactMenus;
                    _sagaParams$delay = sagaParams.delay, delay = _sagaParams$delay === undefined ? _q2.default.delay : _sagaParams$delay, sentryClient = sagaParams.sentryClient;
                    full = null;
                    _context2.prev = 3;

                    // Retrieve the full using the helper method below
                    console.log('[Restaurants] - WebInitSaga: load full first time');
                    return _context2.delegateYield(handleLoadFullSingle(sagaParams, action), 't0', 6);

                case 6:
                    full = _context2.t0;

                    if (!migrateToMultiLocationIfNeeded) {
                        _context2.next = 35;
                        break;
                    }

                    _context2.prev = 8;
                    _context2.next = 11;
                    return (0, _effects.select)(wixInstanceSelector);

                case 11:
                    wixInstance = _context2.sent;
                    hostName = _lodash2.default.get(window, 'location.hostname') || 'manage.wix.com';
                    _context2.next = 15;
                    return (0, _effects.call)(function () {
                        return fetch('https://' + hostName + '/_serverless/multi-location-migration/migrateIfNeeded', {
                            method: "POST",
                            headers: { Authorization: wixInstance.value }
                        }).then(function (r) {
                            return r.json();
                        });
                    });

                case 15:
                    multiLocationData = _context2.sent;
                    isMigrationExecuted = multiLocationData.isMigrationExecuted;

                    if (!isMigrationExecuted) {
                        _context2.next = 29;
                        break;
                    }

                    console.log('[Restaurants] - WebInitSaga: isMigrationExecuted is true, load full again');
                    _context2.prev = 19;
                    return _context2.delegateYield(handleLoadFullSingle(sagaParams, action), 't1', 21);

                case 21:
                    full = _context2.t1;
                    _context2.next = 29;
                    break;

                case 24:
                    _context2.prev = 24;
                    _context2.t2 = _context2['catch'](19);

                    console.log('[Restaurants] - WebInitSaga: load full failed after site migrated first time');
                    _context2.next = 29;
                    return (0, _effects.put)(_WebInitActions.actions.loadFullFailure({ error: _context2.t2 }));

                case 29:
                    _context2.next = 35;
                    break;

                case 31:
                    _context2.prev = 31;
                    _context2.t3 = _context2['catch'](8);

                    console.log('[Restaurants] - WebInitSaga: ML migration has been failed');
                    logError(_context2.t3, '[WebInitSaga] ML migration failed. ', sentryClient);

                case 35:
                    if (!full.locations) {
                        _context2.next = 41;
                        break;
                    }

                    _context2.next = 38;
                    return (0, _effects.put)(_LocationsActions.actions.setLocations({ locations: full.locations }));

                case 38:
                    if (!loadCompactMenus) {
                        _context2.next = 41;
                        break;
                    }

                    _context2.next = 41;
                    return (0, _effects.put)(_LocationsActions.actions.loadCompactMenus({ orgId: full.restaurant.id, locale: full.restaurant.locale, locations: full.locations }));

                case 41:
                    _context2.next = 43;
                    return (0, _effects.put)(_WebInitActions.actions.loadFullSuccess({ full: full, skipI18nRequestChange: skipI18nRequestChange }));

                case 43:
                    _context2.next = 49;
                    break;

                case 45:
                    _context2.prev = 45;
                    _context2.t4 = _context2['catch'](3);
                    _context2.next = 49;
                    return (0, _effects.put)(_WebInitActions.actions.loadFullFailure({ error: _context2.t4 }));

                case 49:
                    if (!(system !== 'client')) {
                        _context2.next = 51;
                        break;
                    }

                    return _context2.abrupt('return');

                case 51:
                    iterationId = (0, _guid2.default)();

                    latestIterationId = iterationId;

                    // Wait a 'refresh-time'
                    timeout = 60000;
                    _context2.next = 56;
                    return (0, _effects.call)(function () {
                        return delay(timeout);
                    });

                case 56:
                    if (!(iterationId !== latestIterationId)) {
                        _context2.next = 58;
                        break;
                    }

                    return _context2.abrupt('return');

                case 58:
                    _context2.next = 60;
                    return (0, _effects.select)(currentLocationSelector);

                case 60:
                    locationId = _context2.sent;
                    _context2.next = 63;
                    return (0, _effects.put)(_WebInitActions.actions.loadFull((0, _extends3.default)({}, action.payload, { locationId: locationId, skipWebServer: true })));

                case 63:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[3, 45], [8, 31], [19, 24]]);
}

/**
 * Handle user request to switch secondary locale. This saga will only need to store the information in the
 * local storage.
 */
function handleSecondaryLocale() {
    var _ref3, secondarySwitched, _i18n;

    return _regenerator2.default.wrap(function handleSecondaryLocale$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.select)(i18nSelector);

                case 2:
                    _ref3 = _context3.sent;
                    secondarySwitched = _ref3.secondarySwitched;

                    try {
                        _i18n = _LocalStorage2.default.get('i18nstore');

                        _LocalStorage2.default.put('i18nstore', (0, _extends3.default)({}, _i18n, { secondarySwitched: secondarySwitched }));
                    } catch (e) {}

                case 5:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

// ============================================================================
// PRIVATE HELPER METHODS
// ============================================================================

function handleLoadFullSingle(sagaParams, action) {
    var openrest, fetch, uuid, window, _Intl, LocalStorage, authentication, restClient, mappingClient, _action$payload2, facebookPageId, system, forceId, skipWebServer, chainBranchId, locationId, loadCompactMenus, useMultilocation, wixInstance, full, originFull, instanceId, originInstanceId, _appId, metasiteId, language, result, accessToken, restaurant, userId, _accessToken, bsmMode;

    return _regenerator2.default.wrap(function handleLoadFullSingle$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    openrest = sagaParams.OpenrestService, fetch = sagaParams.fetch, uuid = sagaParams.uuid, window = sagaParams.window, _Intl = sagaParams.Intl, LocalStorage = sagaParams.LocalStorage, authentication = sagaParams.authentication, restClient = sagaParams.restClient, mappingClient = sagaParams.mappingClient;
                    _action$payload2 = action.payload, facebookPageId = _action$payload2.facebookPageId, system = _action$payload2.system, forceId = _action$payload2.forceId, skipWebServer = _action$payload2.skipWebServer, chainBranchId = _action$payload2.chainBranchId, locationId = _action$payload2.locationId, loadCompactMenus = _action$payload2.loadCompactMenus, useMultilocation = _action$payload2.useMultilocation;
                    _context4.next = 4;
                    return (0, _effects.select)(wixInstanceSelector);

                case 4:
                    wixInstance = _context4.sent;
                    full = null;
                    originFull = null;
                    _context4.prev = 7;
                    instanceId = _lodash2.default.get(wixInstance, 'parsed.instanceId');
                    originInstanceId = _lodash2.default.get(wixInstance, 'parsed.originInstanceId');
                    _appId = wixInstance.appId;
                    metasiteId = getMetasiteId(wixInstance);
                    language = window.uxLanguage || window.RESTAURANTS_PARAMS && window.RESTAURANTS_PARAMS.accountLanguage;

                    // Retrieve the 'restaurant-full' associated to the request

                    console.log('[Restaurants] - WebInitSaga: handleLoadFullSingle: useMultilocation= ' + useMultilocation);

                    _context4.next = 16;
                    return (0, _OrganizationFullRetrieval.retrieveOrganizationFull)({
                        openrest: openrest,
                        facebookPageId: facebookPageId,
                        forceId: forceId || chainBranchId,
                        webserver: skipWebServer ? null : window,
                        language: language,
                        fetch: fetch,
                        metasiteId: metasiteId,
                        instanceId: instanceId,
                        originInstanceId: originInstanceId,
                        instance: wixInstance.value,
                        locationId: locationId,
                        appId: _appId,
                        restClient: restClient,
                        mappingClient: mappingClient,
                        useMultilocation: useMultilocation || loadCompactMenus
                    });

                case 16:
                    result = _context4.sent;


                    full = (result || {}).full;
                    originFull = (result || {}).originFull;

                    if (!(full.restaurant && system === 'backoffice')) {
                        _context4.next = 27;
                        break;
                    }

                    _context4.next = 22;
                    return (0, _effects.select)(accessTokenSelector);

                case 22:
                    accessToken = _context4.sent;
                    _context4.next = 25;
                    return (0, _effects.call)(migrateRestaurant, { restClient: restClient, restaurant: full.restaurant, accessToken: accessToken });

                case 25:
                    restaurant = _context4.sent;

                    full = (0, _extends3.default)({}, full, { restaurant: restaurant });

                case 27:

                    // Cache if forceId to window.full - TODO - is this really needed? If so, explain why
                    if (forceId) {
                        window.full = full;
                    }
                    _context4.next = 34;
                    break;

                case 30:
                    _context4.prev = 30;
                    _context4.t0 = _context4['catch'](7);

                    if (!(_context4.t0 instanceof _OrganizationFullRetrieval.FullDoesNotExist)) {
                        _context4.next = 34;
                        break;
                    }

                    return _context4.abrupt('return', null);

                case 34:
                    if (!(full && !full.restaurant && full.chain)) {
                        _context4.next = 37;
                        break;
                    }

                    if (!(system === 'backoffice')) {
                        _context4.next = 37;
                        break;
                    }

                    throw 'Backoffice inaccessible to chains';

                case 37:
                    if (full) {
                        _context4.next = 61;
                        break;
                    }

                    if (!(system === 'backoffice')) {
                        _context4.next = 60;
                        break;
                    }

                    userId = _lodash2.default.get(wixInstance, 'parsed.uid');

                    // Get the access token (there should be a better way than polling the store every
                    // action! Lets see what they answer this: https://github.com/yelouafi/redux-saga/issues/269)

                    _context4.next = 42;
                    return (0, _effects.select)(accessTokenSelector);

                case 42:
                    _accessToken = _context4.sent;

                case 43:
                    if (_accessToken) {
                        _context4.next = 51;
                        break;
                    }

                    _context4.next = 46;
                    return (0, _effects.take)();

                case 46:
                    _context4.next = 48;
                    return (0, _effects.select)(accessTokenSelector);

                case 48:
                    _accessToken = _context4.sent;
                    _context4.next = 43;
                    break;

                case 51:
                    _context4.next = 53;
                    return (0, _effects.select)(function (state) {
                        return _lodash2.default.get(state, 'session.bsmMode');
                    });

                case 53:
                    bsmMode = _context4.sent;
                    _context4.next = 56;
                    return createNewRestaurantFromOriginFull({ userId: userId, originFull: originFull, accessToken: _accessToken, openrest: openrest, wixInstance: wixInstance, fetch: fetch, Intl: _Intl, uuid: uuid, bsmMode: bsmMode, LocalStorage: LocalStorage, authentication: authentication, restClient: restClient, mappingClient: mappingClient });

                case 56:
                    full = _context4.sent;


                    // In the background, set organization's products. We don't care for response, since we
                    // can't really do anything about it.  We do this for that case that the user provisioned
                    // an app, bought premium, and only then went into the dashboard.
                    fetch('/helpers/postadd?instance=' + wixInstance.value + '&appId=' + wixInstance.appId);

                    _context4.next = 61;
                    break;

                case 60:
                    // else to if system === 'backoffice'
                    full = {
                        restaurant: originFull.restaurant,
                        menu: originFull.menu,
                        isOriginFull: true
                    };

                case 61:
                    return _context4.abrupt('return', full);

                case 62:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[7, 30]]);
}

function migrateRestaurant(_ref4) {
    var restClient = _ref4.restClient,
        restaurant = _ref4.restaurant,
        accessToken = _ref4.accessToken;

    if (restaurant) {
        if ((0, _fixInvalidDeliveryInfos.getInvalidDeliveryInfos)(restaurant).length > 0) {
            return (0, _fixInvalidDeliveryInfos.fixInvalidDeliveryInfos)({ restaurant: restaurant, restClient: restClient, accessToken: accessToken });
        }
    }

    return restaurant;
}

function getMetasiteId(wixInstance) {
    try {
        return wixInstance && wixInstance.instance && wixInstance.instance.getMetasiteIdCalculate();
    } catch (err) {
        console.log('failed calculating metasiteId', err);
    }
}

var i18nSelector = exports.i18nSelector = function i18nSelector(state) {
    return state.i18n || {};
};
var i18nDataSelector = exports.i18nDataSelector = function i18nDataSelector(state) {
    return state.i18nData || {};
};
var wixInstanceSelector = exports.wixInstanceSelector = function wixInstanceSelector(state) {
    return state.wixInstance;
};
var accessTokenSelector = exports.accessTokenSelector = function accessTokenSelector(state) {
    return state.jointLoginInfo.accessToken;
};
var wixInstalledAppsSelector = exports.wixInstalledAppsSelector = function wixInstalledAppsSelector(state) {
    return state.wixInstalledApps.apps;
};
var currentLocationSelector = exports.currentLocationSelector = function currentLocationSelector(state) {
    return _lodash2.default.get(state, 'locations.currentLocation');
};

var randomLatLng = { lat: Math.random() * 180 - 90, lng: Math.random() * 180 - 90 }; // Only randomize once per execution for testing.

var USER_TO_DISTRIBUTOR_ID = {
    '0fe75971-3520-4488-97fc-fc8a47e71b28': 'food.co.il'
};

function getEmptyOrganization(_ref5) {
    var userId = _ref5.userId,
        locale = _ref5.locale,
        _ref5$currency = _ref5.currency,
        currency = _ref5$currency === undefined ? 'USD' : _ref5$currency,
        defaultDispatchType = _ref5.defaultDispatchType;

    var locale = locale;
    var address = {
        latLng: randomLatLng,
        formatted: 'Pick address',
        countryCode: 'US'
    };
    var contact = { phone: DEFAULT_PHONE_NUMBER };
    var colorScheme = { theme: 'light', background: '#000000', font: '#000000', border: '#000000', imageBackground: '#000000', imageBorder: '#000000', buttonFont: '#000000', buttonUp: '#000000', buttonDown: '#000000', buttonOver: '#000000', categoryFont: '#000000', categoryUp: '#000000', categoryDown: '#000000', categoryOver: '#000000' };
    var openTimes = {};
    var title = {};title[locale] = '[new]';

    var properties = {};
    properties['com.openrest'] = (0, _stringify2.default)({
        wixmenu: {
            menuview: 'center',
            widgets: {
                description: null,
                variations: null,
                shortcut: 'hidden',
                price: null,
                specials: 'hidden',
                phone: 'hidden',
                address: 'hidden',
                openinghours: 'hidden'
            }
        },
        wixrestaurants: {
            futureOrders: {
                scheduleAsNewMinutes: 0
            }
        }
    });

    var reservations = {
        futureDelayMins: {
            min: 30,
            max: MAX_DELAY_MINUTES
        },
        partySize: {
            min: 1,
            max: 6
        },
        heldForMins: 15,
        pendingApproval: true,
        availability: {
            exceptions: [{
                reason: 'closed',
                available: false
            }]
        },
        properties: {}
    };

    var orders = {
        future: {
            delayMins: {
                max: 7 * 24 * 60,
                min: 1 * 24 * 60
            },
            disabled: true
        },
        asap: {
            preOrderMins: 60
        },
        availability: { exceptions: [{ start: null, end: null, available: false }] },
        properties: {}
    };

    var organization = {
        type: 'restaurant',
        distributorId: USER_TO_DISTRIBUTOR_ID[userId] || '8408044704064049', /* wix.com' */
        title: title,
        colorScheme: colorScheme,
        contact: contact,
        address: address,
        currency: currency,
        locale: locale,
        locales: [locale],
        timezone: 'America/Los_Angeles',
        openTimes: openTimes,
        paymentTypes: ['cash'],
        creditcardsInfo: {
            networks: [],
            fields: [],
            collectionMethod: null,
            comment: {}
        },
        deliveryInfos: [{ type: 'takeout', delayMins: 15 }],
        deliveriesInfo: {
            approximateAddresses: 'disallow'
        },
        defaultDispatchType: defaultDispatchType,
        properties: properties,
        media: {},
        orders: orders,
        reservations: reservations
    };

    return organization;
}

function logError(e, message, sentryClient) {
    try {
        e.message = message + (e.message || '');
        sentryClient && sentryClient.captureException(e);
        console.error(e);
    } catch (e2) {
        console.error(e2);
    }
}

function getFullOrgId(full) {
    var id = void 0;

    if (full.restaurant) id = full.restaurant.id;else if (full.chain) id = full.chain.id;else console.error("No 'full' organization found!");

    return id;
}

function getOrganizationWithWixExternalId(org, wixInstance) {
    var externalIds = org.externalIds;

    if (wixInstance.instance.getInstanceId && wixInstance.instance.getInstanceId()) {
        externalIds = (0, _extends3.default)({}, externalIds, {
            'com.wix.instanceId': wixInstance.instance.getInstanceId()
        });
    }

    if (wixInstance.instance.getAppId && wixInstance.instance.getAppId()) {
        externalIds = (0, _extends3.default)({}, externalIds, {
            'com.wix.instanceId.appId': wixInstance.instance.getAppId()
        });
    }

    if (wixInstance.instance.getMetasiteId && wixInstance.instance.getMetasiteId()) {
        externalIds = (0, _extends3.default)({}, externalIds, {
            'com.wix.metasiteId': wixInstance.instance.getMetasiteId()
        });
    }

    return (0, _extends3.default)({}, org, {
        externalIds: externalIds
    });
}

// ============================================================================
// WATCHERS
// ============================================================================

function waitForLoadFull(sagaParams) {
    return _regenerator2.default.wrap(function waitForLoadFull$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    _context11.next = 2;
                    return (0, _effects.takeEvery)(_WebInitActions.types.LOAD_FULL, handleLoadFull.bind(null, sagaParams));

                case 2:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked5, this);
}

function waitForSecondaryLocale(sagaParams) {
    return _regenerator2.default.wrap(function waitForSecondaryLocale$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return (0, _effects.takeEvery)(I18nActions.types.I18N_SWITCH_TO_SECONDARY, handleSecondaryLocale.bind(null, sagaParams));

                case 2:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked6, this);
}

// ============================================================================
// DEFAULT SAGA EXPORT
// ============================================================================

function webInitRootSaga(sagaParams) {
    return _regenerator2.default.wrap(function webInitRootSaga$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    _context13.next = 2;
                    return (0, _effects.all)([(0, _effects.fork)(handleInit.bind(null, sagaParams)), (0, _effects.fork)(waitForLoadFull.bind(null, sagaParams)), (0, _effects.fork)(waitForSecondaryLocale.bind(null, sagaParams))]);

                case 2:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked7, this);
}